module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-57x57.040908b2eb01c9e0aa5b5a42a12fc3dd.png";